import { render, staticRenderFns } from "./DisplaySwitch.vue?vue&type=template&id=6783f22a&"
import script from "./DisplaySwitch.vue?vue&type=script&lang=js&"
export * from "./DisplaySwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports